module.exports = __webpack_public_path__ + "static/media/tarja-linhas-maquiagem.31491bfd.jpg";